import { RunObservabilitySeverity, RunWorkerFinding } from "types/generated";

import { RUN_OBSERVABILITY_FINDING_SEVERITIES_BY_RANK } from "./constants";
import {
  RunObservabilityFinding,
  RunObservabilityFindingSeverity,
  RunObservabilityFindingsBySeverity,
} from "./types";

const isRunObservabilityFinding = (finding: RunWorkerFinding): finding is RunObservabilityFinding =>
  finding.severity !== RunObservabilitySeverity.None;

export const getRunObservabilityFindings = (
  findings: RunWorkerFinding[] | null | undefined
): RunObservabilityFinding[] => findings?.filter(isRunObservabilityFinding) ?? [];

export const groupRunObservabilityFindingsBySeverity = (
  findings: RunObservabilityFinding[]
): RunObservabilityFindingsBySeverity => ({
  [RunObservabilitySeverity.Major]: findings.filter(
    ({ severity }) => severity === RunObservabilitySeverity.Major
  ),
  [RunObservabilitySeverity.Minor]: findings.filter(
    ({ severity }) => severity === RunObservabilitySeverity.Minor
  ),
});

export const getDefaultRunObservabilityFindingSeverity = (
  findingsBySeverity: RunObservabilityFindingsBySeverity
): RunObservabilityFindingSeverity =>
  RUN_OBSERVABILITY_FINDING_SEVERITIES_BY_RANK.find(
    (severity) => findingsBySeverity[severity].length > 0
  ) ?? RUN_OBSERVABILITY_FINDING_SEVERITIES_BY_RANK[0];
